import assetPath from '/app/packages/lebenslauf/articles/src/assets/carlos-barquero.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')